// Glass UI Components
// Reusable components for the liquid glass design system

import GlassCard from './GlassCard.vue';
import GlassButton from './GlassButton.vue';
import GlassInput from './GlassInput.vue';
import GlassSelect from './GlassSelect.vue';
import GlassModal from './GlassModal.vue';
import GlassAlert from './GlassAlert.vue';
import GlassTable from './GlassTable.vue';
import GlassOverlay from './GlassOverlay.vue';
import GlassSpinner from './GlassSpinner.vue';
import GlassCheckbox from './GlassCheckbox.vue';
import GlassTabs from './GlassTabs.vue';
import GlassTab from './GlassTab.vue';
import GlassFileInput from './GlassFileInput.vue';
import GlassCollapse from './GlassCollapse.vue';
import GlassDatepicker from './GlassDatepicker.vue';
import GlassTextarea from './GlassTextarea.vue';
import AnimatedBackground from './AnimatedBackground.vue';
import PageLayout from './PageLayout.vue';

// Export individual components
export {
  GlassCard,
  GlassButton,
  GlassInput,
  GlassSelect,
  GlassModal,
  GlassAlert,
  GlassTable,
  GlassOverlay,
  GlassSpinner,
  GlassCheckbox,
  GlassTabs,
  GlassTab,
  GlassFileInput,
  GlassCollapse,
  GlassDatepicker,
  GlassTextarea,
  AnimatedBackground,
  PageLayout
};

// Export as Vue plugin for global registration
export default {
  install(Vue) {
    Vue.component('GlassCard', GlassCard);
    Vue.component('GlassButton', GlassButton);
    Vue.component('GlassInput', GlassInput);
    Vue.component('GlassSelect', GlassSelect);
    Vue.component('GlassModal', GlassModal);
    Vue.component('GlassAlert', GlassAlert);
    Vue.component('GlassTable', GlassTable);
    Vue.component('GlassOverlay', GlassOverlay);
    Vue.component('GlassSpinner', GlassSpinner);
    Vue.component('GlassCheckbox', GlassCheckbox);
    Vue.component('GlassTabs', GlassTabs);
    Vue.component('GlassTab', GlassTab);
    Vue.component('GlassFileInput', GlassFileInput);
    Vue.component('GlassCollapse', GlassCollapse);
    Vue.component('GlassDatepicker', GlassDatepicker);
    Vue.component('GlassTextarea', GlassTextarea);
    Vue.component('AnimatedBackground', AnimatedBackground);
    Vue.component('PageLayout', PageLayout);
  }
};
